/* 🤖 this file was generated by svg-to-ts */
export const matIconTextRotationDown: {
  name: 'text-rotation-down';
  data: string;
} = {
  name: 'text-rotation-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m6 20 3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"/></svg>`
};
